import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalBySchema } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import type { StatusTooltipComponent } from './status_tooltip';

import styles from '../approval_detailed_status_icon.module.css';

export const SuccessStatuses: React.FC<{
  approvedBy: AssetsApprovalBySchema[];
  approvedByUser: boolean;
  StatusTooltip: StatusTooltipComponent;
}> = ({ approvedBy, approvedByUser, StatusTooltip }) => {
  const statuses = [];
  if (approvedBy.length > 0) {
    statuses.push(
      <div key="approve-status-content" className={styles.status_content}>
        <StatusTooltip label={approvedByUser ? 'Approved by you' : 'Approved'}>
          <div className={styles.status_icon}>
            <Icon name={approvedByUser ? 'ra_approved_by_me' : 'ra_approved'} />
          </div>
        </StatusTooltip>
        {approvedBy.length > 1 ? (
          <div className={styles.counter}>{approvedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_success, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};
